import { Routes } from '@angular/router';
import { environment } from '../../../environments/environment';
import { ClientsComponent } from '../../admin/components/clients/clients.component';
import { DataAdministrationComponent } from '../../admin/components/data-administration/data-administration.component';
import { ManagementComponent } from '../../admin/components/management/management.component';
import { RecordingReviewComponent } from '../../admin/components/management/recording-review/recording-review.component';
import { UsersComponent } from '../../admin/components/users/users.component';
import { DataPreviewComponent } from '../../client/components/data-preview/data-preview.component';
import { LandingInfoComponent } from '../../client/components/landing-page/landing-info/landing-info.component';
import { LandingContactUsComponent } from '../../client/components/landing-page/landing-contact-us/landing-contact-us.component';
import { LandingHomeComponent } from '../../client/components/landing-page/landing-home/landing-home.component';
import { LandingListComponent } from '../../client/components/landing-page/landing-list/landing-list.component';
import { authenticationGuard } from '../guards/authentication.guard';
import { LandingPublishFormComponent } from '../../client/components/landing-page/landing-publish-form/landing-publish-form.component';
import { LandingPricingComponent } from '../../client/components/landing-page/landing-pricing/landing-pricing.component';
import { SettingsComponent } from '../components/settings/settings.component';

export const routes: Routes = [
	{
		path: 'account/:mode',
		loadComponent: () => import('../components/account/login/login.component').then(m => m.LoginComponent),
	},
	{ path: 'admin', redirectTo: 'admin/data-administration/clipping', pathMatch: 'full' },
	{
		path: 'admin',
		canActivate: [authenticationGuard],
		loadComponent: () => import('../../admin/components/admin-layout/admin-layout.component').then(m => m.AdminLayoutComponent),
		children: [
			{ path: 'data-administration/:type', component: DataAdministrationComponent },
			{ path: 'clients', component: ClientsComponent },
			{ path: 'users', component: UsersComponent },
			{ path: 'management/:type', component: ManagementComponent },
			{ path: 'recording-schedules', redirectTo: 'settings?section=recording-schedules' },
			{ path: 'recordings', redirectTo: 'settings?section=recordings', pathMatch: 'full' },
			{ path: 'recordings/:id', component: RecordingReviewComponent },
			{ path: 'social', loadComponent: () => import('../../admin/components/social/social.component').then(m => m.SocialComponent) },
			{ path: 'autotag-settings', loadComponent: () => import('../../admin/components/autotag-settings/autotag-settings.component').then(m => m.AutotagSettingsComponent) },
			{ path: 'settings', component: SettingsComponent },
		],
	},
	{
		path: 'client',
		canActivate: [authenticationGuard],
		loadComponent: () => import('../../client/components/client-layout/client-layout.component').then(m => m.ClientLayoutComponent),
		children: [
			{ path: 'data-preview/:type', component: DataPreviewComponent },
			{ path: 'profile', component: SettingsComponent }
		],
	},
];

if (environment.reseller.useLandingPage) {
	routes.push({
		path: '',
		loadComponent: () => import('../../client/components/landing-page/landing-page.component').then(m => m.LandingPageComponent),
		children: [
			{ path: '', component: LandingHomeComponent },
			{ path: 'list/:type', component: LandingListComponent },
			{ path: 'info/:type', component: LandingInfoComponent },
			{ path: 'contact', component: LandingContactUsComponent }, { path: 'unsubscribe', redirectTo: 'contact', pathMatch: 'full' },
			{ path: 'publish-form', component: LandingPublishFormComponent },
			{ path: 'pricing', component: LandingPricingComponent },
    	],
  	});
}

routes.push({ path: '**', redirectTo: environment.reseller.useLandingPage ? '' : 'account/login', pathMatch: 'full' });